<template>
<div class="homePreview">
    <a class="auctionFont fontLine fontLine color333" :href="`https://auction.artron.net/meeting_detail/${list.sessionCode}`" target="_blank">{{list.name}}</a>
    <div class="info mt3">
        <span class="color999 auctionFont fontLine">预展时间：</span><span class="auctionFont color333">{{list.auctionTime}}</span>
    </div>
    <div class="info">
        <span class="color999 auctionFont fontLine">预展地点：</span><span class="auctionFont color333">{{list.auctionLocation}}</span>
    </div>
    <div class="info">
        <span class="color999 auctionFont fontLine">拍卖时间：</span><span class="auctionFont color333">{{list.previewTime}}</span>
    </div>
    <div class="info">
        <span class="color999 auctionFont fontLine">拍卖地点：</span><span class="auctionFont color333">{{list.previewLocation}}</span>
    </div>
    <div class="info" v-if="list.result !== 0">
        <span class="color999 auctionFont fontLine">专场信息：</span><span class="auctionFont color333">{{list.result}}个</span>
    </div>
</div>
</template>

<script>
export default {
    name: "homeAuctionPreview",
    props:["result", "list"],
    data(){
        return{
            dataObj:{
                seriesName:'中国嘉德2021秋季拍卖会',
                seriesUrl:'https://auction.artron.net/ZGJD-0005/PMH213315/',
                preTime:"2022.03.24~03.26",
                preAddress:'嘉德艺术中心（北京市东城区王府井大街1号）',
                aucTime:'2022.03.27~03.30',
                aucAddress:'嘉德艺术中心 A厅（北京市东城区王府井大街1号）、嘉德艺术中心 B厅...',
                specialInfo:'15个',
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.homePreview{
    .info{
        line-height: 24px;
    }
    .mt3{
        margin-top: 3px;
    }
}
</style>